import * as React from 'react';
import {labelStyle} from './constants';

// Styles for a span element to match the sizing of default labels of ExpressionEditor
export const Label = ({
  children,
  automationId,
}: {
  children: React.ReactNode;
  automationId?: string;
}) => (
  <span
    data-automation-id={
      typeof automationId === 'string'
        ? automationId
        : 'symbols-dataType-contentType'
    }
    style={labelStyle}
  >
    {children}
  </span>
);
